import React from 'react';

interface PowerIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

const PowerIcon: React.FC<PowerIconProps> = ({
  size = 24,
  color = '#0098D9',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 21.8028C10.7453 21.8028 9.68589 21.3707 8.82167 20.5065C7.95767 19.6425 7.52567 18.5831 7.52567 17.3285H2.17967C1.78012 17.3285 1.42812 17.1761 1.12367 16.8715C0.819005 16.5668 0.666672 16.2148 0.666672 15.8155C0.666672 12.677 1.67134 9.98559 3.68067 7.74115C5.69023 5.4967 8.21123 4.28648 11.2437 4.11048V0.0078125H12.7563V4.11048C15.7888 4.28648 18.3098 5.4967 20.3193 7.74115C22.3287 9.98559 23.3333 12.677 23.3333 15.8155C23.3333 16.2148 23.181 16.5668 22.8763 16.8715C22.5719 17.1761 22.2199 17.3285 21.8203 17.3285H16.4743C16.4743 18.5831 16.0423 19.6425 15.1783 20.5065C14.3141 21.3707 13.2547 21.8028 12 21.8028ZM2.17967 15.8155H21.8203C21.8203 12.9761 20.8659 10.5676 18.957 8.58981C17.0479 6.61204 14.7294 5.62315 12.0017 5.62315C9.27412 5.62315 6.95523 6.61204 5.04501 8.58981C3.13478 10.5676 2.17967 12.9761 2.17967 15.8155ZM12.0033 20.2898C12.8284 20.2898 13.5278 20.0024 14.1013 19.4275C14.6749 18.8524 14.9617 18.1527 14.9617 17.3285H9.03834C9.03834 18.1558 9.32623 18.8561 9.902 19.4295C10.4776 20.003 11.178 20.2898 12.0033 20.2898Z"
        fill={color}
      />
    </svg>
  );
};

export default PowerIcon;
